import { Control, Controller, FieldValues } from "react-hook-form";

import FormControlLabel from "@mui/material/FormControlLabel";
import { useTheme } from "@mui/material/styles";
import { StyledCheckbox } from "../../buttons";

interface Props<TValues extends FieldValues> {
  id: string;
  name: string;
  control: Control<TValues>;
  label: React.ReactNode;
  dataTestId?: string;
  disabled?: boolean;
}

export const FormCheckbox = <TValues extends FieldValues>({
  id,
  name,
  control,
  label,
  dataTestId = "checkbox",
  disabled,
}: Props<TValues>) => {
  const theme = useTheme();

  return (
    <Controller
      /* eslint-disable  @typescript-eslint/no-explicit-any */
      name={name as any}
      control={control}
      render={({ field }) => (
        <FormControlLabel
          sx={{ alignItems: "center" }}
          disabled={disabled}
          control={
            <StyledCheckbox
              sx={{
                marginRight: theme.spacing(1),
                marginLeft: theme.spacing(2),
              }}
              id={id}
              data-testid={dataTestId}
              checked={field.value}
              disabled={disabled}
              squareIcon
            />
          }
          label={label}
          {...field}
        />
      )}
    />
  );
};
export default FormCheckbox;
